import { useEffect, useState, useCallback } from 'react';
import { queryApi } from 'src/api/queryApi';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';

const useQueryDetails = (queryID) => {
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState(null);
  const queue = useSelector((state) => state.queue || []);
  const queueItem = queue.find((item) => item.queryID === Number(queryID));

  const fetchQueryDetails = useCallback(async () => {
    try {
      const response = await queryApi.fetchQueryByID(queryID);

      setQuery(response);
    } catch (error) {
      toast.error('Error fetching query details:', error);
    } finally {
      if (!queueItem || queueItem.progress === 100) {
        setLoading(false);
      }
    }
  }, [queryID, queueItem]);

  useEffect(() => {
    fetchQueryDetails();
    let pollInterval;
    if (queueItem && queueItem.progress !== 100) {
      pollInterval = setInterval(fetchQueryDetails, 1000);
    }

    return () => {
      if (pollInterval) {
        clearInterval(pollInterval);
      }
    };
  }, [queryID, queueItem?.progress, queueItem, fetchQueryDetails]);

  const isProcessing = queueItem && queueItem.progress !== 100;

  return {
    loading: Boolean(loading),
    isProcessing: Boolean(isProcessing),
    query,
    refetch: fetchQueryDetails,
    queueProgress: queueItem?.progress || 0,
  };
};

export default useQueryDetails;
